import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TargetIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 22.421 24.165",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 24.165),
    children: [/*#__PURE__*/jsx("path", {
      d: "m21.314 8.537a10.442 10.442 0 1 1 -9.043-7.729"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.671 9.848a5.629 5.629 0 1 1 -5.463-4.272"
    }), /*#__PURE__*/jsx("path", {
      d: "m5.734 20.04-.809 3.214"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.987 20.04.8 3.214"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.929 16.78a5.625 5.625 0 1 1 4.869-4.94"
    }), /*#__PURE__*/jsx("path", {
      d: "m10.383 21.614a10.446 10.446 0 1 1 10.286-5.981"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.214 10.801a.4.4 0 1 0 .4.4.4.4 0 0 0 -.4-.4z"
    })]
  });
};

export { PM2TargetIcon };
//# sourceMappingURL=target.js.map
